import React, { useState } from "react";
import { Button, Box, Modal, Typography, TextField } from "@mui/material";

interface DatePickerModalProps {
  open: boolean;
  onClose: () => void;
  onDateSelect: (date: string) => void;
  title?: string;
}

const DatePickerModal: React.FC<DatePickerModalProps> = ({
  open,
  onClose,
  onDateSelect,
  title = "Select a Date",
}) => {
  const [selectedDate, setSelectedDate] = useState<string>("");

  const handleSave = () => {
    if (selectedDate) {
      onDateSelect(selectedDate);
    }
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 300,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <TextField
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          fullWidth
        />

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button onClick={onClose} sx={{ mr: 1 }} color="secondary">
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleSave}>
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DatePickerModal;
